/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';

	const slider = () => {
		$('.story-slider01').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			prevArrow: '<a class="slick-prev" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg><img src="/common/images/arrow_left_grd.svg" class=""></a>',
			nextArrow: '<a class="slick-next" href="#"><svg class=""><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg><img src="/common/images/arrow_right_grd.svg" class=""></svg></a>',
			dots: true,
			autoplay: false
		});
		$(window).on('load', function(){
			// arrowの位置調節
			if($(window).width() < 768) {
				for(let i=0; i < $('.story-slider01').length; i++) {
					if($('.story-slider01').eq(i).find('.slick-prev').length) {
						let imgHeight = $('.story-slider01').eq(i).find('.slick-list img').eq(0).height() + 60;
						let arrowpos = (imgHeight / 2) - ($('.story-slider01').eq(i).find('.slick-prev').eq(0).height() / 2);
						console.log(arrowpos);
						$('.story-slider01').eq(i).find('.slick-prev').eq(0).css('top',arrowpos);
						$('.story-slider01').eq(i).find('.slick-next').eq(0).css('top',arrowpos);
					}
				}
			}
		});
	}

	const storyItemKeywordAdd = () => {
		if($('.js-story-item').length) {
			let lang = '';
			if(location.pathname.split('/')[1] === 'english') {
				lang = '/english';
			}
			const getJSONstoryItemKeywordAdd = (_lang,tag) => {
	            return $.getJSON(`/ajax${_lang}/news/tags/${tag}.json`);
	        };
	        let count = 0;
	        for(let i=0; i < $('.js-story-item .rt_cf_ng_news_key').length; i++) {
	        	getJSONstoryItemKeywordAdd(lang,$('.js-story-item .rt_cf_ng_news_key').eq(i).text()).then((data) => {
		            console.log(data.rt_bn_news_tag_join,'data');
		            let html = '';
		            let tagname = data.rt_bn_news_tag_join;
		            for(let j=0; j < data.rt_bn_news_tag_join.length; j++) {
		            	console.log(data.rt_bn_news_tag_join[j],'data2');
		            	html += '<li>'+
							'<a href="'+data.rt_bn_news_tag_join[j].tag_link+'" class="story-keyword opacity">'+data.rt_bn_news_tag_join[j].tag_name+'</a>'+
						'</li>';
		            }
		            console.log(html,'html');
		            $('.js-story-item-keyword').eq(i).append(html);
		            count += 1;
		            if(count === $('.rt_cf_ng_news_key').length) {
	                    slider();
	                }
		        });
	        }
	    }
	}

   slider();
   storyItemKeywordAdd();

})(window.jQuery, window.FUNCTIONS);
